import _ from 'lodash';

import { showMessageAction } from 'store/global/actions';

import {
  DRAWER_MESSAGES,
  INVALID_DATE_INPUT_SELECTOR,
} from '../../LoanEditorCustomFormDrawer.constants';

export const getSelectionRequiredMessage = ({
  requiresBorrowerSelection,
  requiresContactSelection,
  requiresClosingCompanySelection,
}) => {
  if (requiresBorrowerSelection) {
    return DRAWER_MESSAGES.BORROWER_REQUIRED_FOR_SAVE;
  }

  if (requiresContactSelection) {
    return DRAWER_MESSAGES.CONTACT_REQUIRED_FOR_SAVE;
  }

  if (requiresClosingCompanySelection) {
    return DRAWER_MESSAGES.CLOSING_COMPANY_REQUIRED_FOR_SAVE;
  }

  return null;
};

export const collectInvalidDateFieldNames = container =>
  _.compact(_.map([...(container?.querySelectorAll(INVALID_DATE_INPUT_SELECTOR) ?? [])], 'name'));

export const withInvalidDateErrors = ({ validationErrors, fieldNames }) =>
  fieldNames.reduce(
    (acc, fieldName) => _.set(acc, fieldName, DRAWER_MESSAGES.INVALID_DATE),
    _.cloneDeep(validationErrors ?? {}),
  );

export const showErrorMessage = ({ dispatch, message }) =>
  dispatch(showMessageAction({ message, variant: 'error' }));
